import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable()
export class TitleControllerService {

  constructor(private title : Title) {

  }

  public setTitle(newTitle: string)
  {
    console.log("Yappi 2");
    this.title.setTitle(newTitle);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/title-controller.service.ts